export const PRIVACY_POLICY_PDF_URL =
  'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VH-Privacy-Policy-1.1.2.pdf';
export const ABOUT_IFU_PDF_URLS = {
  VDA_ABOUT:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VDA-ABS+RevJ%2C+VDA+About+Screen+.pdf',
  VPA_ABOUT:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VPA-ABS+Rev+K%2C+Videa+Perio+Assist+About+Screen.pdf',
  VDA_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VDA-IFU+Rev+E+Videa+Dental+Assist+Instructions+for+Use.pdf',
  VPA_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VPA-IFU+Rev+G%2C+Videa+Perio+Assist+Instructions+for+Use.pdf',
  DSS_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/DSS-IFU+Rev+C+Videa+DSS+Instructions+for+Use.pdf',
  SEG_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/SEG-IFU+Rev+A+Videa+Segmentation+Instructions+for+Use.pdf',
};
export const FR_CA_ABOUT_IFU_PDF_URLS = {
  VDA_ABOUT:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VDA-ABS+Rev+J%2C+VDA+About+Screen_FR.pdf',
  VPA_ABOUT:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VPA-ABS+Rev+K%2C+Videa+Perio+Assist+About+Screen_FR.pdf',
  VDA_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VDA-IFU+Rev+G+Videa+Dental+Assist+Instructions+for+Use_FR.pdf',
  VPA_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/VPA-IFU+Rev+H%2C+Videa+Perio+Assist+Instructions+for+Use_FR.pdf',
  DSS_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/DSS-IFU+Rev+D+Videa+DSS+Instructions+for+Use_FR.pdf',
  SEG_IFU:
    'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/SEG-IFU+Rev+A+Videa+Segmentation+Instructions+for+Use_FR.pdf',
};
export const INSURANCE_CLAIM_MOCK_PDF_URL =
  'https://videahealth-public-assets.s3.us-east-2.amazonaws.com/insurance-pdf-export-demo.pdf';
